export default __webpack_public_path__ + "static/media/vks_phaseII_3.ba8631d3.jpeg";